import { h, FunctionalComponent } from "preact";
import { useMap, useMapEvents } from "react-leaflet";
import L, { LatLng } from "leaflet";
import styles from "./style.module.scss";
import Button from "components/Button/Button";
import MapMarker from "icons/MapMarker";
import CloseIcon from "icons/CloseIcon";
interface DynamicMarkersProps {
    disabled: boolean;
    isAdding: boolean;
    onIsAdding(value: boolean): void;
    onAddressSelected(latLng: LatLng): void;
}

const DynamicMarkers: FunctionalComponent<DynamicMarkersProps> = ({
    disabled,
    isAdding,
    onIsAdding,
    onAddressSelected,
}: DynamicMarkersProps) => {
    const map = useMap();

    useMapEvents({
        click: ({ latlng, originalEvent }) => {
            const target = originalEvent.target;
            const foundTargets =
                target instanceof Element &&
                target.closest(`.${styles.addMarkerButton}`);

            /**  Don't add marker if click is on add marker button or is disabled */
            if (!isAdding || foundTargets || disabled) {
                return;
            }
            onAddressSelected(latlng);
        },
    });

    const handleButtonClick = () => {
        onIsAdding(!isAdding);
        if (isAdding) {
            L.DomUtil.removeClass(
                map.getContainer(),
                "crosshair-cursor-enabled",
            );
            // L.DomUtil.addClass(map.getContainer(), "leaflet-grab");
        } else {
            // L.DomUtil.removeClass(map.getContainer(), "leaflet-grab");
            L.DomUtil.addClass(map.getContainer(), "crosshair-cursor-enabled");
        }
    };

    return (
        <Button
            type="tertiary"
            className={styles.addMarkerButton}
            disabled={disabled}
            onClick={handleButtonClick}
        >
            {isAdding ? (
                <CloseIcon
                    fill={"#ffffff"}
                    className={styles.addMarkerCloseIcon}
                />
            ) : (
                <MapMarker fill={"#ffffff"} className={styles.addMarkerIcon} />
            )}
            {!isAdding && <span>+</span>}
        </Button>
    );
};

export default DynamicMarkers;
